import React, { useState, useEffect, useRef, createContext } from "react";

const ActionPlansContext = createContext();

export const ActionPlansConsumer = ActionPlansContext.Consumer;

const ActionPlansProvider = (props) => {
  const [actionPlans, setActionPlans] = useState([]);

  return (
    <ActionPlansContext.Provider
      value={{
        actionPlans,
        setActionPlans,
      }}
    >
      {props.children}
    </ActionPlansContext.Provider>
  );
};

export default ActionPlansContext;

export { ActionPlansProvider, ActionPlansContext };
